module.exports = __webpack_public_path__ + "img/heart.b086d41f.png";